import React from "react";
import {
  Box,
  Typography,
  Container,
  useTheme,
  useMediaQuery,
  Chip,
} from "@mui/material";
import aboutUs from "../../assets/about/whatWeDoSection.jpg";

export default function WhatWeDoSection() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 8, md: 12 },
        overflow: "hidden",
        background:
          "linear-gradient(135deg, #071525 0%, #082d63 55%, #06111f 100%)",
        color: "#fff",
      }}
    >
      {/* Background Graphics */}
      <Box
        sx={{
          position: "absolute",
          width: 420,
          height: 420,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,200,83,0.22), transparent 65%)",
          top: -140,
          right: -120,
          animation: "floatGlow 7s ease-in-out infinite",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.12), transparent 65%)",
          bottom: -100,
          left: -80,
          animation: "floatGlow 9s ease-in-out infinite",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
          opacity: 0.35,
        }}
      />

      <Container sx={{ position: "relative", zIndex: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: "center",
            gap: { xs: 6, md: 8 },
          }}
        >
          {/* Left Content */}
          <Box sx={{ flex: 1 }}>
            <Chip
              label="SAP • DIGITAL • AUTOMATION"
              sx={{
                mb: 2,
                color: "#00c853",
                bgcolor: "rgba(0,200,83,0.12)",
                border: "1px solid rgba(0,200,83,0.35)",
                fontWeight: 700,
                letterSpacing: 1,
                fontSize: 13,
              }}
            />

            <Typography
              component="h2"
              sx={{
                mb: 3,
                fontSize: { xs: "2rem", sm: "2.4rem", md: "3rem" },
                fontWeight: 600,
                lineHeight: 1.15,
                letterSpacing: "-0.8px",
              }}
            >
              What We Do
            </Typography>

            <Typography
              sx={{
                mb: 3,
                fontSize: { xs: "0.8rem", md: "1rem" },
                lineHeight: 1.5,
                textAlign: "justify",
                color: "rgba(255,255,255,0.78)",
              }}
            >
              At Zencon, our extensive experience in client collaboration has
              empowered us to developed 50+ pre-configured and bespoke SAP
              solutions that enable faster implementation at reduced costs -
              delivering accelerated value and quicker time-to-market.
            </Typography>

            <Typography
              sx={{
                mb: 4,
                fontSize: { xs: "0.8rem", md: "1rem" },
                lineHeight: 1.5,
                color: "rgba(255,255,255,0.78)",
                textAlign: "justify",
              }}
            >
              Our SAP S/4HANA offerings span assessment, migration, and
              end-to-end implementation. Through process automation, system
              integration, IIoT, RFID, QR Code, and Barcode solutions, we help
              organizations gain visibility, agility, and operational
              excellence.
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              {/* {["50+ SAP Solutions", "30+ Customers", "8+ Years Expertise"].map(
                (item) => (
                  <Box
                    key={item}
                    sx={{
                      px: 2.5,
                      py: 1.2,
                      borderRadius: "999px",
                      bgcolor: "rgba(255,255,255,0.08)",
                      border: "1px solid rgba(255,255,255,0.14)",
                      backdropFilter: "blur(12px)",
                      fontSize: "0.85rem",
                      fontWeight: 600,
                    }}
                  >
                    {item}
                  </Box>
                ),
              )} */}
            </Box>
          </Box>

          {/* Right Visual */}
          <Box
            sx={{
              flex: 1,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                maxWidth: 520,
                borderRadius: "28px",
                p: 1.5,
                background:
                  "linear-gradient(145deg, rgba(255,255,255,0.22), rgba(255,255,255,0.04))",
                border: "1px solid rgba(255,255,255,0.18)",
                boxShadow: "0 30px 80px rgba(0,0,0,0.45)",
                backdropFilter: "blur(18px)",
                animation: "floatCard 6s ease-in-out infinite",
              }}
            >
              <Box
                component="img"
                src={aboutUs}
                alt="What We Do"
                sx={{
                  width: "100%",
                  display: "block",
                  borderRadius: "22px",
                  objectFit: "cover",
                  minHeight: { xs: 280, md: 390 },
                  boxShadow: "0 18px 50px rgba(0,0,0,0.35)",
                  transition: "0.5s ease",
                  "&:hover": {
                    transform: "scale(1.025)",
                  },
                }}
              />

              {/* Floating Graphic Cards */}
              <Box
                sx={{
                  position: "absolute",
                  top: { xs: 18, md: 28 },
                  left: { xs: -8, md: -35 },
                  px: 2,
                  py: 1.3,
                  borderRadius: "16px",
                  bgcolor: "rgba(7,21,37,0.78)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  backdropFilter: "blur(14px)",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.35)",
                  animation: "pulseCard 3s ease-in-out infinite",
                }}
              >
                <Typography sx={{ fontSize: 12, color: "#00c853" }}>
                  Business Automation
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: 800 }}>
                  SAP S/4HANA
                </Typography>
              </Box>

              {/* <Box
                sx={{
                  position: "absolute",
                  right: { xs: 10, md: -25 },
                  bottom: { xs: 18, md: 35 },
                  px: 2,
                  py: 1.3,
                  borderRadius: "16px",
                  bgcolor: "rgba(255,255,255,0.9)",
                  color: "#071525",
                  boxShadow: "0 14px 40px rgba(0,0,0,0.25)",
                  animation: "pulseCard 3.8s ease-in-out infinite",
                }}
              >
                <Typography sx={{ fontSize: 12, color: "#082d63" }}>
                  Intelligent Solutions
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: 800 }}>
                  50+
                </Typography>
              </Box> */}
            </Box>
          </Box>
        </Box>
      </Container>

      <style>
        {`
          @keyframes floatGlow {
            0%, 100% { transform: translateY(0px) scale(1); }
            50% { transform: translateY(25px) scale(1.08); }
          }

          @keyframes floatCard {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-14px); }
          }

          @keyframes pulseCard {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-8px); }
          }
        `}
      </style>
    </Box>
  );
}
